
const dashboard = () => import('../views/finance/dashboard.vue')
const drillCost = () => import('../views/finance/statistic/drill_cost.vue')
const drillManHour = () => import('../views/finance/statistic/drill_manhour.vue')

export default [
    {
        path: '/finance/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'finance',
        }
    },
    {
        path: '/f/statistic/drill_cost',
        component: drillCost,
        meta: { name: '钻头成本核算', en_name: "drill_cost", module_name: "finance", auth_id: 71101 }
    },
    {
        path: '/f/statistic/drill_manhour',
        component: drillManHour,
        meta: { name: '钻头工时统计', en_name: "drill_manhour", module_name: "finance", auth_id: 71103 }
    },
]
